import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { formControlClasses } from '@mui/material';

export default function AddExpertCommitteeConvenor() {

  const [errors, setErrors] = useState({});
  const [expertCommitteeData, setExpertCommitteeData] = useState([]); 
  const [selectedOption, setSelectedOption] = useState(null); 
  const [name, setName] = useState('');
  const [year, setYear] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [email, setEmail] = useState('');
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const { http } = Api();
  const navigate = useNavigate();
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/");
  }

  useEffect(() => {
    const getExpertCommitteeList = async () => {
      http.get('/Admin/expert-committee-convenor/getExpertCommitteeList')
        .then((response) => {
          setExpertCommitteeData(response.data.data);
        }).catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";
          if (status === 500 || error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/admin/"), 5000);
          } else {
            toast.error(message);
          }
        });
    };

    getExpertCommitteeList();
  }, []);
  const validateForm = () => {
    let hasError = false;
    let updatedErrors = {};
    if (!selectedOption) {
      updatedErrors.expert_id = 'Please select an Expert Committee Convenor.';
      hasError = true;
    }
    if (!name.trim()) {
      updatedErrors.name = 'Name is required.';
      hasError = true;
    }

    if (!year.trim()) {
      updatedErrors.year = 'Year is required.';
      hasError = true;
    }

    const trimmedMobileNumber = mobileNumber.trim();
    if (!trimmedMobileNumber) {
      updatedErrors.mobileNumber = 'Phone number is required.';
      hasError = true;
    }
    if (!email.trim()) {
      updatedErrors.email = 'Email is required.';
      hasError = true;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      updatedErrors.email = 'Enter a valid email address.';
      hasError = true;
    }

    setErrors(updatedErrors);
    return !hasError;
  };


  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    window.location.reload();
  }

  const cancelForm = () => {
    window.location.reload();
  };

  const handlefirstsubmit = () => {
    if (validateForm()) {
      //e.preventDefault();
      const payloads = {
        expert_id: selectedOption ? selectedOption.value : null,
        name: name,
        year: year,
        mobile: mobileNumber,
        status: "Active",
        email: email
        
      };
      const saveNewUserData = () => {
        http.post('/Admin/expert-committee-convenor', payloads).then((response) => {
        
          if (response.data.status_code === 'MSG1') {
            toast.success("User data inserted successfully");
            setTimeout(() => {
              cancelForm();
            }, 3000);

          }
          else {
            toast.error("Failed to save User Data");
          }
        }).catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";

          if (status === 500 || error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/admin/"), 5000);
          } else {
            toast.error(message);
          }
        });
      };
      saveNewUserData();
    }
    else {
      toast.error("Please fill mandatory fields");
    }
  };
  const handleExpertCommitteeChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handleMobileChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 11);
    setMobileNumber(digitsOnly);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  const currentYear = new Date().getFullYear();

  const yearOptions = [];
  for (let y = 2025; y <= currentYear; y++) {
    yearOptions.push(y);
  }

  return (
    <>
      <ToastContainer />
      <Template>


        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Add Expert Committee Convenors</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="col-md-12 txt-aln pdg14">
                        <div className="row">
                          <div className="col">


                          
                              <div className="row ">
                                <label className="col-md-5 txt-aln-lft">Select Expert Committee 
                                <span className="errorclr">*</span></label>
                                <div className="col-md-7 txt-aln-lft">
                                  <Select name='expert_id' value={selectedOption}
                                    options={expertCommitteeData.map((item) => ({
                                      value: item.id,
                                      label: item.expert_committee_name,
                                    }))}
                                    styles={customStyles}
                                    onChange={handleExpertCommitteeChange}
                                    placeholder="Select Expert Committee Convenor"
                                  />
                                   {errors.expert_id && <p className="text-danger">{errors.expert_id}</p>}
                                </div>                               
                              </div>
                            
             
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Name <span className="errorclr">*</span></label>
                              <div className="col-md-7 txt-aln-lft">
                                <input type="text" className="form-control input-air-primary" name="name" value={name} onChange={(e) => setName(e.target.value)}
                                />
                                {errors.name && <p className="text-danger">{errors.name}</p>}
                              </div>
                            </div>
                           
                            <div className="row">
                                  <label className="col-md-5 txt-aln-lft">
                                    Year <span className="errorclr">*</span>
                                  </label>
                                  <div className="col-md-7 txt-aln-lft">
                                    <select
                                      className="form-control input-air-primary"
                                      name="year"
                                      value={year}
                                      onChange={(e) => setYear(e.target.value)}
                                    >
                                      <option value="">Select Year</option>
                                      {yearOptions.map((y) => (
                                        <option key={y} value={y}>
                                          {y}
                                        </option>
                                      ))}
                                    </select>

                                    {errors.year && <p className="text-danger">{errors.year}</p>}
                                  </div>
                            </div>
                          
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Phone Number <span className="errorclr">*</span></label>
                              <div className="col-md-7 txt-aln-lft">
                                <input type="text" className="form-control input-air-primary" name="mobileNumber" value={mobileNumber} onChange={handleMobileChange} maxLength={11} inputMode="numeric" pattern="[0-9]{11}"
                                />
                                {errors.mobileNumber && <p className="text-danger">{errors.mobileNumber}</p>}
                              </div>
                            </div>

                            {/* <div className="row">
                              <label className="col-md-5 txt-aln-lft">Landline Number</label>
                              <div className="col-md-7">
                                <input type="text" className="form-control input-air-primary" name="landlineNumber" value={landlineNumber} onChange={(e) => setLandlineNumber(e.target.value.replace(/[^0-9-]/g, '').slice(0, 13))} maxLength={13} inputMode="numeric" placeholder="e.g. 0481-2733309"
                                />
                                {errors.landlineNumber && <p className="text-danger">{errors.landlineNumber}</p>}
                              </div>
                            </div> */}
                          
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Email <span className="errorclr">*</span></label>
                              <div className="col-md-7 txt-aln-lft">  
                                <input type="email" className="form-control input-air-primary" name="email" value={email} onChange={(e) => setEmail(e.target.value)}
                                />
                                {errors.email && <p className="text-danger">{errors.email}</p>}
                              </div>
                            </div>

                          </div>
                        </div>
                        <div>
                          <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                          <input className="btn btn-light" type="reset" style={{border:'2px solid black'}} value="Cancel" onClick={cancelForm} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
